document.addEventListener("DOMContentLoaded", function() {
  const stepsSection = document.querySelector('.bundle__section-steps');
  const miniCart = document.querySelector('.bundle__steps-right');

  function checkPosition() {
    if (stepsSection) {
      const stepsRect = stepsSection.getBoundingClientRect();

      if (stepsRect.top <= 0) {
        miniCart.classList.add('show')
      } else {
        miniCart.classList.remove('show')
      }
    }
  }

  // Initial check on page load
  checkPosition();
  window.addEventListener('scroll', checkPosition);
});

document.addEventListener('DOMContentLoaded', () => {
  const bundleMainScreen = document.querySelector('.bundle__section-main');
  const bundleMainContent = document.querySelector('.bundle__section-steps');

  const scrollToSection = (section) => {
    const offsetTop = section.offsetTop; // Adjust as needed
    window.scrollTo({
      top: offsetTop,
      behavior: 'smooth'
    });
  };

  const initBundleMainScreen = (mainScreen) => {
    const startBundleBtn = document.querySelector('.bundle__main-btn');
    startBundleBtn.addEventListener('click', () => {
      const startBundleContent = document.querySelector('#bundle__0');
      scrollToSection(startBundleContent);
    });
  };
  const initBundle = (bundleContent) => {
    const bundleCart = document.querySelector('#bundle__cart-content');

    let countBundleMax = +bundleContent
    .querySelector('[data-count-max-default]')
    .getAttribute('data-count-max-default');
    let countBundleCurrent = 0;
    let total = 0;
    let totalDiscount = 0;
    const cartProducts = [];

    const productsCard = bundleContent.querySelectorAll(
        '.bundle__product-card'
    );
    const calcDiscountedPrice = () => {
      const $allPriceEl = document.querySelectorAll('.price__new');
      $allPriceEl.forEach(priceEl => {
        const currencySymbol = priceEl.dataset.originalPrice[0];
        const originalPrice = +priceEl.dataset.originalPrice.replace(/\D/g, '');
        const $priceEl = priceEl.querySelector('.price');
        let discountedPrice;
        switch (countBundleMax) {
          case 2:
            discountedPrice = originalPrice - (originalPrice * (window.bundle_pack_2_discount / 100)).toFixed(2);
            $priceEl.innerText = `${currencySymbol}${discountedPrice}`
            break;
          case 3:
            discountedPrice = originalPrice - (originalPrice * (window.bundle_pack_3_discount / 100)).toFixed(2);
            $priceEl.innerText = `${currencySymbol}${discountedPrice}`
            break;
        }
      })
    }

    /* START: PRODUCT CARD */
    const initProductCard = () => {
      let t = 0;
      const initProductMedia = (product, variantContent) => {
        const productCarousel = product.querySelector('.media__slider-main');
        const productCarouselPrev = product.querySelector(
            '.media__slider-prev'
        );
        const productCarouselNext = product.querySelector(
            '.media__slider-next'
        );

        let swiperSettings = {
          slidesToShow: 1,
          dots: true,
          prevArrow: productCarouselPrev,
          nextArrow: productCarouselNext,
        };

        if (!variantContent) {
          productCarousel &&
          $(productCarousel).slick({
            ...swiperSettings,
          });
        } else {
          if ($(productCarousel).hasClass('slick-initialized')) {
            $(productCarousel).slick('unslick');
          }
          $(productCarousel).remove();

          const parentMedia = product.querySelector('.bundle__product-media');
          const isMediaSliderVariant = product.querySelector(
              '.media__slider__variant'
          );

          if (parentMedia && !isMediaSliderVariant) {
            const createNewSlider = document.createElement('div');
            createNewSlider.classList.add(
                'media__slider-main',
                'media__slider__variant',
                'hidden'
            );

            const variantImages =
                variantContent.querySelectorAll('.metafield__img');

            variantImages.forEach((el) => {
              const copy = el.cloneNode(true);
              createNewSlider.append(copy);
            });

            parentMedia.append(createNewSlider);

            $(createNewSlider).slick({
              ...swiperSettings,
            });

            createNewSlider.classList.remove('hidden');
          }
        }
      };

      const initProductSelect = () => {
        const changeProductCardInfo = (product, currentVariant) => {
          const getData = currentVariant;
          const varaintPrice = getData.getAttribute('data-price');
          const varaintPriceCom = getData.getAttribute('data-com-price');
          const varaintOption1 = getData.getAttribute('data-option1');
          const varaintOption2 = getData.getAttribute('data-option2');
          const variantAvailable = getData.getAttribute('data-available');

          const productPriceNewUI = product.querySelector('.price__new .price');
          const productPriceOld = product.querySelector('.price__old .price');

          const productOption1Parent = product
          .querySelector(`.product-info-variants [data-index="option1"]`)
          .closest('.product-info-variants');
          const prodcutOption1Title = productOption1Parent.querySelector(
              '.variants-title .variant-current'
          );

          const productOption2Parent = product
          .querySelector(`.product-info-variants [data-index="option2"]`)
          ?.closest('.product-info-variants');
          const prodcutOption2Title = productOption2Parent?.querySelector(
              '.variants-title .variant-current'
          );

          const prodcutOptionAvailable = productOption1Parent.querySelector(
              '.variants-title .variant-instock'
          );

          const productBtn = product.querySelector('.product__add-to-cart');
          const productBtnText = productBtn.querySelector('span');
          const isAvailable = variantAvailable === 'true' ? true : false;

          productPriceNewUI && (productPriceNewUI.textContent = varaintPrice);
          productPriceOld &&
          (productPriceOld.textContent = varaintPriceCom
              ? varaintPriceCom
              : ' ');
          prodcutOption1Title &&
          (prodcutOption1Title.textContent = varaintOption1
              ? varaintOption1
              : ' ');
          prodcutOption2Title &&
          (prodcutOption2Title.textContent = varaintOption2
              ? varaintOption2
              : ' ');
          prodcutOptionAvailable &&
          (prodcutOptionAvailable.textContent = isAvailable
              ? 'In stock'
              : 'Sold Out');

          if (!isAvailable) {
            productBtn.classList.add('sold__out');
            productBtnText.textContent = 'Sold Out';
          } else {
            productBtn.classList.remove('sold__out');
            productBtnText.textContent = 'Add';
          }

          const variantImage = getData.querySelector('.data__variant-image');
          initProductMedia(product, variantImage);
        };

        const findCurrentVariant = (obj) => {
          const { product, productColorSelect, productSizeSelect } = obj;
          const $productAddToCartBtn = product.querySelector('.product__add-to-cart');
          const $price = product.querySelector('.price__new');
          const $compareAtPrice = product.querySelector('.price__old .price');

          const variantAll = product.querySelectorAll(
              '.hidden-variants .data__variant-info'
          );

          let currentVariant = null;

          if (productColorSelect && productSizeSelect) {
            const currentColor = product.querySelector(
                '.swatch__list--color .swatch__item.active'
            );
            const currentColorValue = currentColor
            .querySelector('a')
            .getAttribute('data-value');
            const currentColorIndex = currentColor
            .closest('.swatch__list--color')
            .getAttribute('data-index');

            const currentSize = product.querySelector(
                '.swatch__list--size .swatch__item.active'
            );
            const currentSizeValue = currentSize.getAttribute('value');
            const currentSizeIndex = currentSize
            .closest('.swatch__list--size')
            .getAttribute('data-index');

            const colorVariants = [];
            variantAll.forEach((el) => {
              const dataOption = el.getAttribute(`data-${currentColorIndex}`);
              if (dataOption === currentColorValue) {
                colorVariants.push(el);
              }
            });

            colorVariants.forEach((el) => {
              const dataOption = el.getAttribute(`data-${currentSizeIndex}`);
              if (dataOption === currentSizeValue) {
                currentVariant = el;
              }
            });
          }

          if (productColorSelect && !productSizeSelect) {
            const currentColor = product.querySelector(
                '.swatch__list--color .swatch__item.active'
            );
            const currentColorValue = currentColor
            .querySelector('a')
            .getAttribute('data-value');
            const currentColorIndex = currentColor
            .closest('.swatch__list--color')
            .getAttribute('data-index');

            variantAll.forEach((el) => {
              const dataOption = el.getAttribute(`data-${currentColorIndex}`);
              if (dataOption === currentColorValue) {
                currentVariant = el;
              }
            });
          }
          currentVariant && changeProductCardInfo(product, currentVariant);

          if (currentVariant) {
            $price.dataset.originalPrice = currentVariant.dataset.price;
            $compareAtPrice.innerText = currentVariant.dataset.price;
            $productAddToCartBtn.dataset.id = currentVariant.dataset.id;
            calcDiscountedPrice();
          }
        };

        productsCard.forEach((product) => {
          const productSizeSelect = product.querySelector(
              '.swatch__list--size'
          );
          const productColorSelect = product.querySelectorAll(
              '.swatch__list--color .swatch__item'
          );

          if (productSizeSelect) {
            const selectOptions = productSizeSelect.querySelectorAll('option');

            productSizeSelect.classList.add('select-hidden');

            const selectContainer = document.createElement('div');
            selectContainer.className = 'select';
            productSizeSelect.parentNode.insertBefore(
                selectContainer,
                productSizeSelect
            );
            selectContainer.appendChild(productSizeSelect);

            const selectStyled = document.createElement('div');
            selectStyled.className = 'select-styled';

            selectContainer.appendChild(selectStyled);

            const selectOptionsList = document.createElement('ul');
            selectOptionsList.className = 'select-options';
            selectContainer.appendChild(selectOptionsList);

            selectOptions.forEach((option) => {
              const listItem = document.createElement('li');
              const optionCotnent = option.textContent.trim();
              listItem.textContent = optionCotnent;
              listItem.setAttribute('rel', optionCotnent);
              listItem.setAttribute('value', optionCotnent);
              selectOptionsList.appendChild(listItem);

              listItem.addEventListener('click', () => {
                const value = listItem.getAttribute('value');
                selectStyled.textContent = listItem.textContent;
                selectStyled.setAttribute('rel', listItem.textContent);
                selectStyled.setAttribute('value', value);

                selectOptionsList.classList.remove('active');
                selectStyled.classList.remove('active');

                const selectOptionActive =
                    productSizeSelect.querySelector('option.active');
                selectOptionActive &&
                selectOptionActive.classList.remove('active');
                option.classList.add('active');

                const listOptionActive =
                    selectOptionsList.querySelector('li.active');
                listOptionActive && listOptionActive.classList.remove('active');
                listItem.classList.add('active');

                findCurrentVariant({
                  product,
                  productColorSelect,
                  productSizeSelect,
                });
              });
            });

            /* START: Trigger for init select size */
            const initSizeSelected = () => {
              const selectSizeAll =
                  document.querySelectorAll('.select-options');
              selectSizeAll.forEach((select) => {
                const firstSize = select.querySelector('li');
                firstSize.click();
              });
            };
            initSizeSelected();
            /* END: Trigger for init select size */

            selectStyled.addEventListener('click', () => {
              selectOptionsList.classList.toggle('active');
              selectStyled.classList.toggle('active');
            });
          }

          if (productColorSelect) {
            productColorSelect.forEach((productColor) => {
              productColor.addEventListener('click', () => {
                const currentActiveColor = product.querySelector(
                    '.swatch__list--color .swatch__item.active'
                );

                currentActiveColor &&
                currentActiveColor.classList.remove('active');
                productColor.classList.add('active');

                findCurrentVariant({
                  product,
                  productColorSelect,
                  productSizeSelect,
                });
              });
            });

            const firstColorEl = product.querySelector(
                '.swatch__list--color .swatch__item:first-child'
            );
            firstColorEl && firstColorEl.click();
          }

          /* initProductMedia(product); */
        });
      };
      initProductSelect();

      const initChangeVariant = () => {};
      initChangeVariant();
    };
    initProductCard();
    /* END: PRODUCT CARD */

    /* START: BUNDLE CONTENT */
    /* START: CHANGE COUNT BUNDLE */
    const changeCountMaxBundle = (count = countBundleMax) => {
      countBundleMax = count;
      // renderCountUI();
      // visibilityCartItem();
      visibilityCategoryItem();
      calcDiscountedPrice();
    };

    const renderCountUI = () => {
      const countMaxUI = bundleCart.querySelectorAll('.count__number-all');
      countMaxUI.forEach((countUI) => {
        countUI.textContent = countBundleMax;
      });
    };

    const visibilityCartItem = () => {
      const bundleCotnentUI = bundleCart.querySelectorAll(
          '.bundle__cart-cotnent'
      );
      bundleCotnentUI.forEach((contentUI) => {
        const bundleLineProduct =
            contentUI.querySelectorAll('.bundle__cart-item');
        bundleLineProduct.forEach((lineProduct, i) => {
          const isLineHide = lineProduct.classList.contains('hidden');
          const isLineHideBorder =
              lineProduct.classList.contains('hide__border');
          const removeBtn = lineProduct.querySelector('.cart__item-remove');

          const isHideRemoveBtn = removeBtn?.classList.contains('hidden');

          if (i + 1 > countBundleMax) {
            lineProduct.classList.add('hidden');
            bundleLineProduct[i - 1].classList.add('hide__border');
          } else {
            isLineHide && lineProduct.classList.remove('hidden');
            isLineHideBorder && lineProduct.classList.remove('hide__border');
          }

          if (lineProduct.classList.contains('empty') && countBundleMax !== 3) {
            removeBtn?.classList.add('hidden');
          } else {
            isHideRemoveBtn && removeBtn.classList.remove('hidden');
          }
        });
      });
    };

    const visibilityCategoryItem = () => {
      const stepCategory = document.querySelectorAll('.bundle__section-step');
      const stepLastCategory = stepCategory[stepCategory.length - 1];
      const isHiddenLastCategory =
          stepLastCategory?.classList.contains('hidden__step');
      if (stepLastCategory && countBundleMax < 3) {
        stepLastCategory.classList.add('hidden__step');
      } else {
        isHiddenLastCategory &&
        stepLastCategory.classList.remove('hidden__step');
      }
    };

    const initChangeCount = () => {
      const defaultItem = document.querySelector(
          `[data-bundle-max="${countBundleMax}"]`
      );
      defaultItem.classList.add('active');
      changeCountMaxBundle();
    };

    initChangeCount();
    /* END: CHANGE COUNT BUNDLE */
    const initBundleContent = () => {
      const bundleContents = document.querySelectorAll('.bundle__section-step');

      /* START: FIRST RENDER PRODUCT CATEGORY */
      const initProductCategory = (btn) => {
        btn.click();
      };
      /* END: FIRST RENDER PRODUCT CATEGORY */

      bundleContents.forEach((bundleContent, i) => {
        bundleContent.setAttribute('id', `bundle__${i}`);
        const bundleContentBtns = bundleContent.querySelectorAll(
            '.bundle__step-button'
        );

        const toggleButtonActive = (btn) => {
          const currentActiveBtn = bundleContent.querySelector(
              '.bundle__step-button.active'
          );
          currentActiveBtn && currentActiveBtn.classList.remove('active');
          btn.classList.add('active');
        };

        const toggleCategoryContent = (content, parent) => {
          const categoryContent = parent.querySelector(
              `.bundle__product-category[data-category="${content}"]`
          );
          const categoryCurrentContent = parent.querySelector(
              `.bundle__product-category.show`
          );

          categoryCurrentContent &&
          categoryCurrentContent.classList.remove('show');

          categoryContent.classList.add('show');
        };

        bundleContentBtns.forEach((btn, i_Btn) => {
          btn.addEventListener('click', () => {
            if (i == 0) {
              const bundleMax = +btn.getAttribute('data-bundle-max');
              const nextSection = bundleContents[i + 1];
              scrollToSection(nextSection);
              changeCountMaxBundle(bundleMax);
            }
            toggleButtonActive(btn);

            const categoryBtnContent = btn.getAttribute('data-category');
            categoryBtnContent &&
            toggleCategoryContent(categoryBtnContent, bundleContent);
          });

          i !== 0 && i_Btn == 0 && initProductCategory(btn);
        });
      });
    };
    initBundleContent();
    /* END: BUNDLE CONTENT */

    /* START: CART ACTION */
    const initHandlerCartLineEmpty = () => {
      const cartContents = bundleMainContent.querySelectorAll(
          '.bundle__cart-cotnent'
      );
      cartContents.forEach((cartCotnent) => {
        const cartItems = cartCotnent.querySelectorAll('.bundle__cart-item');
        cartItems.forEach((cartItem, i) => {
          const cartItemRemoveBtn =
              cartItem?.querySelector('.cart__item-remove');
          cartItem.addEventListener('click', () => {
            if (cartItem.classList.contains('empty')) {
              const toSection = document.querySelector(`#bundle__${i + 1}`);
              scrollToSection(toSection);
            }
          });

          cartItemRemoveBtn &&
          cartItemRemoveBtn.addEventListener('click', () => {
            if (cartItem.classList.contains('empty') && countBundleMax == 3) {
              const bundleSizeBtn = document.querySelector(
                  `.bundle__step-button[data-bundle-max="${
                      countBundleMax - 1
                  }"]`
              );
              bundleSizeBtn.click();
            }
          });
        });
      });
    };
    initHandlerCartLineEmpty();
    /* END: CART ACTION */
  };

  if (bundleMainScreen && bundleMainContent) {
    initBundleMainScreen(bundleMainScreen);
    initBundle(bundleMainContent);
  }
});